// @flow

export const defer = (): Promise<any> => {
  let res, rej

  const promise = new Promise((resolve, reject) => {
    res = resolve
    rej = reject
  })

  // $FlowFixMe
  promise.resolve = res
  // $FlowFixMe
  promise.reject = rej

  return promise
}
